import { useEffect } from "react";
import { Link } from "react-router-dom";

// Shared wrapper for legal pages — keeps them on-brand (cream canvas, display
// headings) without touching the main site design.
export default function LegalPage({ title, updated, children }) {
  useEffect(() => {
    document.title = `${title} — SugaSpice Bakery & Kitchen`;
  }, [title]);

  return (
    <div className="bg-[#F7F5F0] text-[#1A1A1A]">
      <section className="mx-auto max-w-[820px] px-6 md:px-10 py-16 md:py-24">
        <Link to="/" className="text-xs tracking-[0.2em] uppercase text-[#C8102E] hover:underline">← Back to home</Link>
        <h1 className="font-display text-4xl md:text-5xl uppercase tracking-tight mt-5">{title}</h1>
        {updated && <p className="mt-3 text-sm text-[#5C5C5C]">Last updated: {updated}</p>}
        <div className="legal-prose mt-10 text-[15px] leading-relaxed text-[#2a2a2a] space-y-5">
          {children}
        </div>
      </section>
    </div>
  );
}

// Obvious placeholder for details the business must supply. Highlighted so it's
// impossible to miss before going live.
export function Ph({ children }) {
  return (
    <mark className="bg-amber-200 text-amber-950 px-1.5 py-0.5 rounded font-medium">
      [ {children} ]
    </mark>
  );
}

export function H2({ children }) {
  return <h2 className="font-display text-2xl uppercase tracking-tight mt-10 mb-3 text-[#1A1A1A]">{children}</h2>;
}

export function H3({ children }) {
  return <h3 className="font-semibold text-base mt-6 mb-2">{children}</h3>;
}
